var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-drag-handle",on:{"mousedown":function($event){return _vm.$emit('list-draghandle-click', $event)}}},[_c('icon-drag-indicator',{attrs:{"size":28}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }